export function toDisplayTime(hhmm) {
    if (!hhmm || hhmm.length < 4) return hhmm || '';
    const [h, m] = hhmm.trim().split(':');
    const hour = String(parseInt(h, 10));
    return `${hour}:${m}`;
}
